<template>
    <div class="triz-header flex items-center justify-between px-4 min-h-[48px] sticky top-0 bg-white z-10">
        <div class="triz-header-left flex items-center gap-2 flex-1 overflow-hidden">
            <!-- 标题 -->
            <div class="flex items-center gap-2 flex-shrink-0 w-full overflow-hidden">
                <PtIcon icon="TrizPro" class="text-2xl shrink-0" />
                <span class="text-sm font-bold overflow-hidden text-ellipsis whitespace-nowrap leading-6 pr-2" :title="trizTitle">{{ trizTitle }}</span>
            </div>

        </div>

        <div class="triz-header-right flex items-center gap-3 flex-shrink-0">
            <ShareTools
                v-if="trizMindId"
                class="!p-0 !border-none !relative triz-share-tools"
                :options="shareOptions"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue';
import { PtIcon } from 'patsnap-biz';
import { useTrizState } from '@/composables/chat/use-triz-state';
import { E_ShareType } from '@eureka/services/src/types/share';
import { useRoute } from 'vue-router';
import { useMessages } from '@/composables/chat/use-messages';

import '@/assets/icon/trizPro.svg';

const ShareTools = defineAsyncComponent(() => import('@eureka/shared/share-tools/src/ShareTools.vue'));
const { getVersion } = useMessages();

const { trizTitle } = useTrizState();
const route = useRoute();

const trizMindId = computed(() => route.params.triz_mind_id as string);

const shareOptions = computed(() => ({
    id: trizMindId.value,
    type: E_ShareType.TRIZ_PRO,
    title: trizTitle.value || 'TRIZ MIND',
    trackData: {
        from: 'triz-mind-header',
        solution_version: getVersion.value,
    },
}));

</script>

<style lang="scss">
.triz-share-tools {
    .share-tools-tip {
        @apply hidden;
    }
}
</style>
